import orderApiInstance from "./axiosInstances/orderService";

/**
 * OOD-895 - order-service reads for a KH bundle order. Both endpoints are
 * addressed by the group order id and are only ever called for a row that
 * carries a bundle program key.
 */

/**
 * The bundle line's components with their current schedule, workshop and
 * Prism state, plus the move counters the fee rule uses.
 */
export const fetchBundleProgramOrderContext = (groupOrderId) => {
  return orderApiInstance.get(`/order/bundle/${groupOrderId}/context`);
};

/** Every component move of this order's chain, newest first. */
export const fetchBundleComponentTransfers = (groupOrderId) => {
  return orderApiInstance.get(
    `/order/bundle/${groupOrderId}/component-transfers`
  );
};

/**
 * Re-run Prism enrolment for a bundle order with failed/skipped components,
 * or - with a component offering key - for that one component only.
 * Addressed by the bundle's ORDER LINE id (not the group order id). Convergent
 * on the order-service side: components already enrolled are unaffected, so a
 * retry is always safe. Responds with {attempted, succeeded, failed} counts
 * for this call, plus componentOfferingKey when it was narrowed.
 */
export const retryBundlePrismEnrolment = (
  orderEntityId,
  componentOfferingKey
) => {
  return orderApiInstance.post(
    `/order/bundle/${orderEntityId}/prism-enrolment/retry`,
    null,
    componentOfferingKey
      ? { params: { component: componentOfferingKey } }
      : undefined
  );
};
